import ExternalNetworkService from './ExternalNetworkService';
import ApiService from '@/services/ApiService';

/**
 * QuintoAndar external network service
 */
/* eslint-disable class-methods-use-this */
class QuintoAndarService extends ExternalNetworkService {
  constructor() {
    super('quintoandar');
  }

  /**
   * Get quick display data for a QuintoAndar property
   * @param {string|number} id - Property identifier
   * @returns {Promise} Property data
   */
  async getQuickData(id) {
    const composedURL = `/portals/quintoandar/api3/house/${id}`;
    return ApiService.get(composedURL, undefined, true);
  }

  /**
   * Get properties by identifier list
   * @param {Array<string>} identifiers - List of property identifiers (houses IDs)
   * @returns {Promise} Properties data
   */
  async getPropertiesByIdentifiers(identifiers) {
    const listOfIdentifiers = Array.isArray(identifiers)
      ? identifiers.join(',')
      : identifiers;
    const composedURL = `/portals/quintoandar/api3/house/houses_card?houses_ids=${listOfIdentifiers}`;
    return ApiService.get(composedURL);
  }

  /**
   * Generate shopwindow link for multiple properties
   * @param {Array<string|number>} ids - List of property IDs
   * @returns {Promise} Shopwindow data with link
   */
  async generateShopwindow(ids) {
    const listOfIds = Array.isArray(ids) ? ids.join(',') : ids;
    const composedURL = `/portals/quintoandar/api3/house/shopwindows?ids=${listOfIds}`;
    return ApiService.get(composedURL);
  }
}
/* eslint-enable class-methods-use-this */

export default QuintoAndarService;
